// extracted by mini-css-extract-plugin
module.exports = {"label":"label___3K364","krLabel":"krLabel___282DX"};